import React from "react";
import SecondaryButton from "../buttons/SecondaryButton";

const PDFViewerGPT1 = ({ pdfUrl, handleDelete, handleClose }) => {
  return (
    <div
      className="w-full flex flex-col items-center justify-center"
      style={{
        flex: 1,
        position: "relative",
        backgroundColor: "#f0f0f0",
      }}
    >
      <div className="fixed bottom-24 right-24 transform z-50 flex items-center justify-center">
        <div className="bg-wshadow_50 flex flex-row gap-2 p-2 backdrop-blur-md rounded-md">
          {/* <SecondaryButton
            onClick={() => {
              window.open(pdfUrl, "_blank");
            }}
          >
            Télécharger
          </SecondaryButton> */}
          <SecondaryButton onClick={handleClose}>Fermer</SecondaryButton>
          <SecondaryButton onClick={handleDelete}>Supprimer</SecondaryButton>
        </div>
      </div>

      <iframe
        src={pdfUrl}
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="PDF Viewer"
      />
    </div>
  );
};

export default PDFViewerGPT1;
